import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'households';

export const HOUSEHOLD_ENDPOINTS = {
  retrieveHousehold: (id: string) => formatEndpoint(id, namespace),
};
